import { html, LitElement } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { translateFn } from '../../../../utils/translator.helper';
import { FontSizes } from '../../../../types/common/types';
import { ButtonColors, ButtonTypes } from '../../../../ui/gzButton/types';
import { GzDialogEvents } from '../../../../ui/gzDialog/component/GzDialog';
import { GzCheckboxWebComponent } from '../../../../ui/gzCheckbox';

/**
 * @summary Type here the description of this component
 * @tag gz-dashboard-discard-changes-dialog-content
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-dashboard-discard-changes-dialog-content')
export class GzDashboardDiscardChangesDialogContentWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  /**
   * @internal
   * @type {GzCheckboxWebComponent}
   * @private
   */
  @query('#showAgainCheckbox')
  private showAgainCheckbox: GzCheckboxWebComponent;

  render() {
    return html`
      <gz-text class="pb-2" fontSize="${FontSizes.HEADING_6}"
        >${translateFn('This will discard all changes made to the current view.')}
      </gz-text>

      <gz-checkbox id="showAgainCheckbox" class="pb-4" label="${translateFn('Do not show this again')}"></gz-checkbox>

      <div class="action-buttons">
        <gz-button
          type="${ButtonTypes.OUTLINE}"
          color="${ButtonColors.NEGATIVE}"
          id="discardButton"
          class="mr-2"
          @click="${this.handleDiscardButton}"
        >
          ${translateFn('Discard changes')}
        </gz-button>

        <gz-button type="${ButtonTypes.OUTLINE}" color="${ButtonColors.SECONDARY}" @click="${this.handleCancelButton}">
          ${translateFn('Cancel')}
        </gz-button>
      </div>
    `;
  }

  private handleDiscardButton() {
    this.dispatchEvent(
      new CustomEvent(GzDialogEvents.CONFIRM, {
        bubbles: true,
        composed: true,
        detail: {
          showAgain: !this.showAgainCheckbox.checked,
        },
      })
    );
  }

  private handleCancelButton() {
    this.dispatchEvent(
      new CustomEvent(GzDialogEvents.CANCEL, {
        bubbles: true,
        composed: true,
      })
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-dashboard-discard-changes-dialog-content': GzDashboardDiscardChangesDialogContentWebComponent;
  }
}
